/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Error_RetryInputs */

const en_interview_error_retry = /** @type {(inputs: Interview_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const de_interview_error_retry = /** @type {(inputs: Interview_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const fr_interview_error_retry = /** @type {(inputs: Interview_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reessayer`)
};

const es_interview_error_retry = /** @type {(inputs: Interview_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentar`)
};

const it_interview_error_retry = /** @type {(inputs: Interview_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

const nl_interview_error_retry = /** @type {(inputs: Interview_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw proberen`)
};

const pl_interview_error_retry = /** @type {(inputs: Interview_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponow probe`)
};

const fi_interview_error_retry = /** @type {(inputs: Interview_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yrita uudelleen`)
};

const da_interview_error_retry = /** @type {(inputs: Interview_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proev igen`)
};

const sv_interview_error_retry = /** @type {(inputs: Interview_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foersoek igen`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Interview_Error_RetryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_error_retry = /** @type {((inputs?: Interview_Error_RetryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Error_RetryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_error_retry(inputs)
	if (locale === "fr") return fr_interview_error_retry(inputs)
	if (locale === "es") return es_interview_error_retry(inputs)
	if (locale === "it") return it_interview_error_retry(inputs)
	if (locale === "nl") return nl_interview_error_retry(inputs)
	if (locale === "pl") return pl_interview_error_retry(inputs)
	if (locale === "fi") return fi_interview_error_retry(inputs)
	if (locale === "da") return da_interview_error_retry(inputs)
	if (locale === "sv") return sv_interview_error_retry(inputs)
	return en_interview_error_retry(inputs)
});